import saas from '@/utils/saas'
import Common from '@/utils/saas/common' // 工具类

// 查询个人客户信息
export function getPersonalInfo(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'CUSTOMER_017', data, '客户信息查询')
}
// 个人认证
export function personalAuth(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'CUSTOMER_001', data, '个人认证')
}
// 查询收货地址列表
export function queryAddressPage(data) {
  return Common.createRequest(saas.ServiceName.TERMINAL_API, 'QUERY_ADDRESS', data, '查询收货地址')
}
// 新增收货地址
export function addAddress(data) {
  return Common.createRequest(saas.ServiceName.TERMINAL_API, 'ADD_ADDRESS', data, '新增收货地址')
}
// 修改收货地址
export function updateAddress(data) {
  return Common.createRequest(saas.ServiceName.TERMINAL_API, 'UPDATE_ADDRESS', data, '修改收货地址')
}
// 删除收货地址列表
export function delAddress(data) {
  return Common.createRequest(saas.ServiceName.TERMINAL_API, 'DELETE_ADDRESS', data, '删除收货地址')
}
// 查询企业客户信息
export function getCompanyInfo(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'CUSTOMER_008', data, '查询企业客户信息')
}
// 企业认证
export function companyAuth(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'CUSTOMER_002', data, '企业认证')
}

// 查询账户余额
export function getAccountBalancd(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_account_balance', data, '查询账户余额')
}
// OCR营业执照识别
export function OCRBslIC(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'OCR_BS_LIC', data, 'OCR营业执照识别')
}
// OCR身份证正反识别
export function OCRIdCardFront(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'OCR_ID_CARD_FRONT', data, 'OCR身份证正面识别')
}
// 是否审核通过
export function certificationFlag(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_certification_flag', data, 'OCR身份证正面识别')
}
export function otherInfoSearch(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'person_fxq_other_info_search', data, '个人客户其他信息查询')
}
// 客户过期时间提醒
export function overdueRemind(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_overdue_remind', data, '客户过期时间提醒')
}
// 企业客户其他信息查询
export function shareInfoSearch(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'company_fxq_share_info_search', data, '企业客户其他信息查询')
}
// 企业客户其他信息保存修改
export function shareInfoUpdate(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'company_fxq_share_info_update', data, '企业客户其他信息保存修改')
}
// 个人客户其他信息修改
export function infoUpdate(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'person_fxq_other_info_update', data, '个人客户其他信息修改')
}
// 营业执照
export function customerUpdate(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'company_info_update', data, '营业执照')
}
// 身份证
export function personCertificate(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'person_info_update', data, '身份证')
}
// 查询业务字典
export function queryBusinessDict(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'BUSINESS_DICT_SEARCH', data, '查询业务字典')
}
// 根据code更新开业日期
export function updateOpendate(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'company_update_opendate', data, '根据code更新开业日期')
}

// 查询帐户明细
export function getAccount(data) {
  return Common.createRequest('capital-api', 'MER_ACC_FLOW_SEARCH', data, '查询帐户明细')
}
// 产品线查询
export function productTypeSearch(data) {
  return Common.createRequest('dict-api', 'PROD_QUERY', data, '产品线查询')
}
// 查询账务流水交易类型和子交易类型
export function getAccTradeCode(data) {
  return Common.createRequest('capital-api', 'ACC_TRADE_CODE_SEARCH', data, '查询账务流水交易类型和子交易类型')
}
// 查询dopay账户状态
export function getaccountStatus(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer/detailCustomer', data)
}
// 通过key查找value值
export function getValueByKey(key, vpCollection) {
  // console.log(key);
  // console.log(vpCollection);
  var myC = vpCollection.filter((p) => {
    return p.key === key
  })
  // console.log(myC);
  if (myC.length !== 0) {
    return myC[0].display_name
  } else {
    return key
  }
}

export function statDetailExport(data) {
  return Common.createDownRequest('capital-api', 'MER_ACC_FLOW_SEARCH_DOWNLOAD', data)
}
